var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ancestors',{staticClass:"block ancestors",attrs:{"is-fetching":_vm.isLoading,"ancestors":_vm.ancestors}})
}
var staticRenderFns = []

export { render, staticRenderFns }